<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows>

    <ng-container matColumnDef="DetPS">
        <th mat-header-cell *matHeaderCellDef class="text-center font10">PS</th>
        <td mat-cell *matCellDef="let det" class="text-center font10">
            {{det.DetPS}} </td>
    </ng-container>

    <ng-container matColumnDef="detPcodeCol">
        <th mat-header-cell *matHeaderCellDef class="text-center font10">CPT</th>
        <td mat-cell *matCellDef="let det" class="text-center font10">
            {{det.detPcodeCol}} </td>
    </ng-container>

    <ng-container matColumnDef="detXpect1">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10"> {{engLang ? 'Expect 1': 'Espera 1'}} </th>
        <td mat-cell *matCellDef="let det" class="rtalign font10">
            {{det.detXpect1 ? (makeNum(det.detXpect1) | currency:'USD':'':'0.2-2') : '0.00'}} </td>
    </ng-container>

    <ng-container matColumnDef="detXpect2">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10"> {{engLang ? 'Expect 2': '
            Espera 2 '}} </th>
        <td mat-cell *matCellDef="let det" class="rtalign font10">
            {{det.detXpect2 ? (makeNum(det.detXpect2) | currency:'USD':'':'0.2-2') : '0.00'}} </td>
    </ng-container>

    <ng-container matColumnDef="detPvdo">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10"> {{engLang ? 'Patient': 'Privado'}} </th>
        <td mat-cell *matCellDef="let det" class="rtalign font10">
            {{det.detPvdo ? (makeNum(det.detPvdo) | currency:'USD':'':'0.2-2') : '0.00'}} </td>
    </ng-container>

    <ng-container matColumnDef="detQty">
        <th mat-header-cell *matHeaderCellDef class="text-center font10"> {{engLang ? 'Qty': 'Cant'}} </th>
        <td mat-cell *matCellDef="let det" class="text-center font10">
            {{det.detQty}} </td>
    </ng-container>

    <ng-container matColumnDef="detDesc">
        <!-- <th mat-header-cell *matHeaderCellDef class="font9"> {{engLang ? 'Procedure' : 'Procedimiento'}} </th> -->
        <td mat-cell *matCellDef="let row" class="font10" [attr.colspan]="displayedColumns.length">
            {{row.detDesc}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="det-header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="det-row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['detDesc'];" class="det-row-desc"></tr>

</table>